import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "auth flex flex-align-center full-height" }
const _hoisted_2 = { class: "full-width" }
const _hoisted_3 = { class: "auth__field" }
const _hoisted_4 = { class: "auth__label" }
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = {
  key: 0,
  class: "auth__error"
}
const _hoisted_7 = { class: "auth__field" }
const _hoisted_8 = { class: "auth__label" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = {
  key: 0,
  class: "auth__error"
}
const _hoisted_11 = { class: "flex flex-justify-end" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "error-message" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_transition_expand = _resolveComponent("transition-expand")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.$t('LOGIN.LOGIN')), 1),
      _createElementVNode("form", {
        onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["prevent"]))
      }, [
        _createElementVNode("label", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('COMMON.EMAIL')), 1),
          _withDirectives(_createElementVNode("input", {
            class: "auth__input",
            type: "email",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
            onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["enter"])),
            placeholder: _ctx.$t("COMMON.EMAIL"),
            autofocus: ""
          }, null, 40, _hoisted_5), [
            [
              _vModelText,
              _ctx.email,
              void 0,
              { trim: true }
            ]
          ]),
          (_ctx.errorMessage("Email"))
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.errorMessage("Email")), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("label", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('COMMON.PASSWORD')), 1),
          _withDirectives(_createElementVNode("input", {
            class: "auth__input",
            type: "password",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.password) = $event)),
            onKeyup: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["enter"])),
            placeholder: _ctx.$t("COMMON.PASSWORD")
          }, null, 40, _hoisted_9), [
            [_vModelText, _ctx.password]
          ]),
          (_ctx.errorMessage("Password"))
            ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.errorMessage("Password")), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_router_link, {
            class: "text-button mr-4",
            to: { name: _ctx.PageNames.RequestPassword }
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('LOGIN.FORGOT_PASSWORD')), 1)
            ]),
            _: 1
          }, 8, ["to"]),
          _createElementVNode("button", {
            class: _normalizeClass(["auth__submit", { "is-loading": _ctx.isLoading }]),
            type: "submit",
            disabled: _ctx.isLoading
          }, _toDisplayString(_ctx.$t('LOGIN.LOGIN')), 11, _hoisted_12)
        ])
      ], 32),
      (_ctx.errorMessage("Company"))
        ? (_openBlock(), _createBlock(_component_transition_expand, {
            key: 0,
            class: "mt-2 mb"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.errorMessage("Company")), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}